import { firebaseRef, db } from "../../config/firebaseInitial";
import "firebase/auth";
import firebase from "firebase/app";
import { getUserProfile, eraseUserState } from "../actions/userProfileActions";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

const requestLogin = () => {
  return {
    type: LOGIN_REQUEST
  };
};

const receiveLogin = userId => {
  return {
    type: LOGIN_SUCCESS,
    userId
  };
};

const loginError = error => {
  return {
    type: LOGIN_FAILURE,
    error
  };
};

export const signUp = values => dispatch => {
  dispatch(requestLogin());
  firebaseRef
    .auth()
    .createUserWithEmailAndPassword(values.email, values.password)
    .then(function (firebaseUser) {
      let user = firebaseUser.user;
      verifyEmail(user);
      dispatch(receiveLogin(user.uid));
      insertUserToCollection(values, user.uid);
      dispatch(getUserProfile(user.uid));
    })
    .catch(function (error) {
      dispatch(loginError(error));
      alert(error.message)
    });

};
const insertUserToCollection = (values, uid) => {
  db.collection("user")
    .doc(uid)
    .set({
      fullName: values.fullName,
      email: values.email,
      phoneNumber: values.phoneNumber,
      province: values.province,
      city: values.city,
      hasOrganization: values.hasOrganization,
      organizationName: values.organizationName,
      organizationId: values.organizationId
    })
    .then(function () {
    })
    .catch(function (error) {
    });
};

const verifyEmail = user => {
  user
    .sendEmailVerification()
    .then(function () {

    })
    .catch(function (error) {

    });
};

export const signInUser = (values, history) => dispatch => {
  dispatch(requestLogin());
  firebaseRef
    .auth()
    .signInWithEmailAndPassword(values.email, values.password)
    .then(user => {
      dispatch(receiveLogin(user.user.uid));
      dispatch(getUserProfile(user.user.uid));
      history.push("/");
    })
    .catch(function (error) {
      dispatch(loginError(error.message));
      alert(error.message);
    });
};

//sign out actions
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

const logOut = () => {
  return {
    type: LOGOUT_SUCCESS
  };
};

const logOutError = error => {
  return {
    type: LOGOUT_FAILURE,
    error
  };
};

export const signOutUser = history => dispatch => {
  firebaseRef
    .auth()
    .signOut()
    .then(function () {
      dispatch(logOut());
      dispatch(eraseUserState());
      history.push("/sign-in");
    })
    .catch(function (error) {
      dispatch(logOutError(error));
    });
};

///////// reset password actions
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

const requestResetPassword = () => {
  return {
    type: RESET_PASSWORD_REQUEST
  };
};

const receiveResetPassword = () => {
  return {
    type: RESET_PASSWORD_SUCCESS
  };
};

const ResetPasswordError = error => {
  return {
    type: RESET_PASSWORD_FAILURE,
    error
  };
};
export const resetPassword = email => dispatch => {
  dispatch(requestResetPassword());
  firebase
    .auth()
    .sendPasswordResetEmail(email)
    .then(() => {
      dispatch(receiveResetPassword());
    })
    .catch(error => {

      dispatch(ResetPasswordError(error));
    });
};
